import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-24 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20with%20soft%20flowing%20shapes%20in%20coral%20orange%20and%20cream%20tones%2C%20minimalist%20modern%20design%2C%20gentle%20light%20rays%2C%20atmospheric%20texture%2C%20elegant%20simple%20background%2C%20no%20text%20no%20people%20just%20abstract%20artistic%20composition&width=1920&height=800&seq=cta-bg-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-900/60 to-background-900/80"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-5">
          准备好开始你的观影之旅了吗？
        </h2>
        <p className="text-base md:text-lg text-white/75 mb-8 leading-relaxed">
          探索樱花视频推荐的优质视频平台，享受高清流畅的观影体验。无论你喜欢电影、电视剧还是动漫综艺，这里都有最适合你的选择。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="whitespace-nowrap px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-medium hover:bg-primary-600 transition-all cursor-pointer"
          >
            立即浏览平台
          </Link>
          <Link
            to="/article/2025-best-free-video-platforms-guide"
            className="whitespace-nowrap px-8 py-3.5 rounded-full bg-white/12 text-white text-base font-medium hover:bg-white/20 transition-all cursor-pointer backdrop-blur-sm border border-white/20"
          >
            阅读评测指南
          </Link>
        </div>
      </div>
    </section>
  );
}